var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57496 8.008L10.8124 6.77056C11.9514 5.63153 11.9514 3.7848 10.8124 2.64577V2.64577C9.67337 1.50674 7.82663 1.50674 6.68761 2.64577L5.45017 3.88321M7.92504 9.65791L6.68761 10.8953C5.54858 12.0344 3.70184 12.0344 2.56282 10.8953V10.8953C1.42379 9.75632 1.42379 7.90959 2.56282 6.77056L3.80025 5.53312",
    stroke: "url(#paint0_linear_8_484)",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92507 5.53312L5.4502 8.008",
    stroke: "url(#paint1_linear_8_484)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_484",
    x1: 4.62521,
    y1: 4.70816,
    x2: 8.75,
    y2: 8.83295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_484",
    x1: 5.80375,
    y1: 8.36155,
    x2: 8.27862,
    y2: 5.88668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGrey);
export default __webpack_public_path__ + "static/media/link-grey.18ad67f228d7e1c0df389c7530b8fc76.svg";
export { ForwardRef as ReactComponent };